import { gql } from '@apollo/client'

export type { AssignClient, AssignClientVariables } from './types/index.graphql'

export const ASSIGN_CLIENT = gql`
  mutation AssignClient($assignClientDTO: AssignClientInput!) {
    assignClient(assignClientDTO: $assignClientDTO) {
      success
    }
  }
`
